import { GroupedPromoteTask, OnboardingTask } from '@tiendanube/common';
import { TaskActionData, TaskData } from '../GenericTaskList';

const MOBILE_HIDDEN_TASKS = ['google', 'meta', 'tiktok'];
const NUVEM_MARKETING_HIDDEN_TASKS = ['marketing_nube'];

export const filterPromoteTasks = (
  tasks: GroupedPromoteTask[],
  isMobile: boolean,
  hasAccessToNuvemMarketing: boolean,
): GroupedPromoteTask[] =>
  tasks
    .filter((group) => {
      if (!isMobile || group.name !== 'increase_traffic') return true;

      const allTasksAreHidden = group.tasks.every((task) =>
        MOBILE_HIDDEN_TASKS.includes(task.name),
      );

      return !allTasksAreHidden;
    })
    .map((group) => {
      if (!hasAccessToNuvemMarketing && group.name === 'improve_conversion') {
        return {
          ...group,
          tasks: group.tasks.filter(
            (task) => !NUVEM_MARKETING_HIDDEN_TASKS.includes(task.name),
          ),
        };
      }

      if (isMobile && group.name === 'increase_traffic') {
        return {
          ...group,
          tasks: group.tasks.filter(
            (task) => !MOBILE_HIDDEN_TASKS.includes(task.name),
          ),
        };
      }

      return group;
    });

export const promoteTaskDigest = (
  task: OnboardingTask,
): TaskData & TaskActionData => ({
  id: task.name,
  title: task.title,
  description: task.description,
  iconType: task.name,
  ctaText: task.ctaText,
  ctaLink: task.ctaLink,
  ctaExternal: task.ctaExternal,
});
